import React from 'react';
import { Switch } from 'antd';
import { shutdownAlisaActiveQuery } from '../../../../../shared/api/queries';
import { useShutdownAlisaStateChange } from '../../../changeAlisaState';
import styles from './ToggleAlisaState.module.scss';

const { useShutdownAlisaActive } = shutdownAlisaActiveQuery;

const ToggleAlisaState = ({ shutdown }) => {
  const { data: alisaActive, isFetching: isAlisaActiveFetching } =
    useShutdownAlisaActive(shutdown.alertId);

  const { change, loading } = useShutdownAlisaStateChange();

  return (
    <div className={styles.root}>
      {alisaActive ? 'Включен' : 'Отключен'}
      <Switch
        size="small"
        loading={isAlisaActiveFetching || loading || false}
        checked={typeof alisaActive === 'boolean' ? alisaActive : false}
        onChange={(checked) => {
          change({ shutdownId: shutdown.alertId, data: checked });
        }}
      />
    </div>
  );
};

export default ToggleAlisaState;
